export default __webpack_public_path__ + "static/media/login.dbd3ff84.jpg";